import { type IPurchaseSurchargePeriod } from "@/interfaces/api/purchase-surcharge-period.interface"
import { PurchaseSurchargePeriodRepository } from "@/repositories/purchase-surcharge-period-repository"
import { GenericModelController } from "@/controllers/model-controllers/abstract/generic-model-controller"
import { PurchaseSurchargePeriod } from "@/models/purchase-surcharge-period.model"
import { usePurchaseSurchargePeriodStore } from "@/store/purchase-surcharge-periods.store"
import { storeToRefs } from "pinia"
import { useSocketSynchronizationHandlers } from "@/composables/socket/socket-synchronization-handlers"
import { ODataQueryBuilder } from "@/builder/odata-query-builder"

export class PurchaseSurchargePeriodController extends GenericModelController<
  PurchaseSurchargePeriod,
  IPurchaseSurchargePeriod,
  PurchaseSurchargePeriodRepository
> {
  constructor() {
    const purchaseSurchargePeriodStore = usePurchaseSurchargePeriodStore()
    const { purchaseSurchargePeriods } = storeToRefs(purchaseSurchargePeriodStore)

    const storeFunctionsConfig = {
      collection: purchaseSurchargePeriods
    }

    super(PurchaseSurchargePeriod, storeFunctionsConfig, new PurchaseSurchargePeriodRepository())

    this.socketSynchronizationHandlers = useSocketSynchronizationHandlers(
      PurchaseSurchargePeriod,
      purchaseSurchargePeriods
    )
  }

  public async findByPurchaseItemAndDate(
    purchaseItemId: string,
    date: string
  ): Promise<PurchaseSurchargePeriod | undefined> {
    const query = new ODataQueryBuilder()
      .eq("purchase_item_id", purchaseItemId)
      .le("period_start", date)
      .ge("period_end", date)

    const result = await this.getList({ query })
    return result[0]
  }
}
